import React from 'react';
import { connect } from 'react-redux';

import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import DHCs from './DHCs';
import EndUsers from './EndUsers';
import Products from './Products';

import DHCIcon from '@mui/icons-material/SupervisorAccount';
// import EndUserIcon from '@mui/icons-material/AccountCircle';
import ProductIcon from '@mui/icons-material/Inventory';

const TAB_TYPES = [
    { id: 1, Component: DHCs, IconName: DHCIcon, TabLabel: 'DHCs', Value: 'DHCs' },
    { id: 2, Component: Products, IconName: ProductIcon, TabLabel: 'Products', Value: 'Products' },
    // { id: 3, Component: EndUsers, IconName: EndUserIcon, TabLabel: 'End Users', Value: 'EndUsers' }
]

class Dashboard extends React.Component {
    state = {
        SelectedTab: null
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        let tab = params.get('tab');

        if (!tab) tab = 'DHCs';

        this.onSelectTab(null, tab);
    }

    onSelectTab = (event, SelectedTab) => {
        this.setState({ SelectedTab });

        // Update the URL query parameter
        const params = new URLSearchParams(window.location.search);
        params.set('tab', SelectedTab);
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }

    renderContent = () => {
        var { SelectedTab } = this.state;

        if (SelectedTab === 'DHCs') return <DHCs />
        else if (SelectedTab === 'EndUsers') return <EndUsers />
        else if (SelectedTab === 'Products') return <Products />

        return null;
    }

    renderToggleMenu = () => {
        return (
            <ToggleButtonGroup
                value={this.state.SelectedTab}
                exclusive
                onChange={this.onSelectTab}
                aria-label="text alignment"
                sx={{ display: "flex", justifyContent: "center" }}
            >
                {TAB_TYPES.map(({ id, IconName, TabLabel, Value }) => {
                    return (
                        <ToggleButton key={id} value={Value}>
                            <IconName />&nbsp;&nbsp;{TabLabel}
                        </ToggleButton>
                    );
                })}
            </ToggleButtonGroup>
        );
    }

    render() {
        return (
            <>
                {this.renderToggleMenu()}

                <Box sx={{ height: 20 }} />
                
                {this.renderContent()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UserDetails: state.Auth.UserDetails,

        TryingGetData: state.Regular.TryingGetData,
        TryingGetDataError: state.Regular.TryingGetDataError
    }
}

export default connect(mapStateToProps, {})(Dashboard);